import { createPinia, defineStore, type Pinia } from "pinia";

// import { Region, Namespace } from "@kce2/common/api/commons";

// export interface State {
//   initing: boolean;
//   initFailed: boolean;
//   region: string;
//   namespace: string;
//   namespaces: Namespace[];
//   regions: Region[];
// }

export const useGlobalStore = defineStore("globalStore", {
  //   modules: {},
  //   state: {
  //     initing: false,
  //     initFailed: false,
  //     region: "",
  //     namespace: "",
  //     namespaces: [],
  //     regions: [],
  //   },
  //   mutations: {
  //     setIniting(state: State, initing: boolean) {
  //       state.initing = initing;
  //     },
  //     setInitFailed(state: State, failed: boolean) {
  //       state.initing = false;
  //       state.initFailed = failed;
  //     },
  //     setNamespace(state: State, namespace: string) {
  //       state.namespace = namespace;
  //     },
  //     setRegion(state: State, region: string) {
  //       state.region = region;
  //     },
  //     setNamespaces(state: State, namespaces: Namespace[]) {
  //       state.namespaces = namespaces;
  //     },
  //     setRegions(state: State, regions: Region[]) {
  //       state.regions = regions;
  //     },
  //   },
  //   actions: {},
  //   getters: {
  //     regionInfo(state: State) {
  //       const region = state.regions.filter(
  //         r => r.RegionCode === state.region,
  //       )[0];
  //       return region || null;
  //     },
  //   },
});

let store: Pinia | null = null;

export function getStore() {
  console.assert(store !== null, "store 为 null，使用前请先初始化");
  return store!;
}

export function createStore() {
  store = createPinia();
  return store;
}
